module.exports = __webpack_public_path__ + "img/logo.411a0ad9.png";